// extracted by mini-css-extract-plugin
export default {"outline":"MessageBox_outline__ZGFdG"};